import { useState, useCallback, useEffect } from 'react'

const SCROLL_LOCK_CLASS = 'disable-page-scroll'

// Shared open/close state for the redesigned mobile navigation. State is lifted
// here so the future slimmed mobile menu can read `isActive` from Navigation and
// render in place, without the Hamburger owning it. Mirrors LegacyNavigation.
function useHamburgerStatus() {
  const [isActive, setIsActive] = useState(false)

  const toggle = useCallback(() => {
    setIsActive(state => !state)
  }, [])

  // Lock body scroll while the menu is open. Driven off state so the class
  // stays in sync and is always cleared when the nav unmounts.
  useEffect(() => {
    document.body.classList.toggle(SCROLL_LOCK_CLASS, isActive)

    return () => {
      document.body.classList.remove(SCROLL_LOCK_CLASS)
    }
  }, [isActive])

  // The hamburger only exists below md (960px); the menu is inline above it. If the
  // menu was opened on mobile and the viewport widens to desktop, `isActive` would
  // otherwise stay true and the menu would reappear open on the next return to mobile.
  // Reset it whenever the viewport reaches the desktop layout so the hamburger starts
  // closed each time it becomes relevant again.
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return undefined
    }

    const query = window.matchMedia('(min-width: 960px)')

    function handleChange(event) {
      if (event.matches) {
        setIsActive(false)
      }
    }

    query.addEventListener('change', handleChange)

    return () => query.removeEventListener('change', handleChange)
  }, [])

  return { isActive, toggle }
}

export { useHamburgerStatus }
